import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77c4bc6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_property_details_view"
}
const _hoisted_3 = { class: "card-header border-bottom" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "card-body p-9" }
const _hoisted_8 = { class: "mb-10" }
const _hoisted_9 = { class: "section-header mb-6" }
const _hoisted_10 = { class: "fw-bold text-dark mb-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_12 = { class: "row g-6" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_15 = { class: "info-item mb-4" }
const _hoisted_16 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_17 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_18 = { class: "fw-bold text-gray-800" }
const _hoisted_19 = { class: "info-item mb-4" }
const _hoisted_20 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_21 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_22 = { class: "fw-bold text-gray-800" }
const _hoisted_23 = { class: "info-item mb-4" }
const _hoisted_24 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_25 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_26 = { class: "fw-bold text-gray-800" }
const _hoisted_27 = { class: "info-item mb-4" }
const _hoisted_28 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_29 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_30 = { class: "fw-bold text-gray-800" }
const _hoisted_31 = { class: "info-item mb-4" }
const _hoisted_32 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_33 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_34 = { class: "fw-bold text-gray-800" }
const _hoisted_35 = { class: "info-item" }
const _hoisted_36 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_37 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_38 = { class: "fw-bold text-gray-800" }
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_41 = { class: "info-item mb-4" }
const _hoisted_42 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_43 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_44 = { class: "fw-bold text-gray-800" }
const _hoisted_45 = { class: "info-item mb-4" }
const _hoisted_46 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_47 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_48 = { class: "fw-bold text-gray-800" }
const _hoisted_49 = { class: "info-item mb-4" }
const _hoisted_50 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_51 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_52 = { class: "fw-bold text-gray-800" }
const _hoisted_53 = { class: "info-item mb-4" }
const _hoisted_54 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_55 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_56 = { class: "fw-bold text-gray-800" }
const _hoisted_57 = { class: "info-item" }
const _hoisted_58 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_59 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_60 = { class: "fw-bold text-gray-800" }
const _hoisted_61 = { class: "mb-10" }
const _hoisted_62 = { class: "section-header mb-6" }
const _hoisted_63 = { class: "fw-bold text-dark mb-1" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_65 = { class: "row g-6" }
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_68 = { class: "row g-4" }
const _hoisted_69 = { class: "col-md-3" }
const _hoisted_70 = { class: "info-item" }
const _hoisted_71 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_72 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_73 = { class: "fw-bold text-gray-800" }
const _hoisted_74 = { class: "col-md-3" }
const _hoisted_75 = { class: "info-item" }
const _hoisted_76 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_77 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_78 = { class: "fw-bold text-gray-800" }
const _hoisted_79 = { class: "col-md-3" }
const _hoisted_80 = { class: "info-item" }
const _hoisted_81 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_82 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_83 = { class: "fw-bold text-gray-800" }
const _hoisted_84 = { class: "col-md-3" }
const _hoisted_85 = { class: "info-item" }
const _hoisted_86 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_87 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_88 = { class: "fw-bold text-gray-800" }
const _hoisted_89 = { class: "mb-10" }
const _hoisted_90 = { class: "section-header mb-6" }
const _hoisted_91 = { class: "fw-bold text-dark mb-1" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_93 = { class: "row g-6" }
const _hoisted_94 = { class: "col-lg-6" }
const _hoisted_95 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_96 = { class: "info-item mb-4" }
const _hoisted_97 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_98 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_99 = { class: "badge badge-primary fw-bold" }
const _hoisted_100 = { class: "info-item mb-4" }
const _hoisted_101 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_102 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_103 = { class: "info-item mb-4" }
const _hoisted_104 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_105 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_106 = { class: "fw-bold text-gray-800" }
const _hoisted_107 = { class: "info-item" }
const _hoisted_108 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_109 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_110 = { class: "fw-bold text-gray-800" }
const _hoisted_111 = { class: "col-lg-6" }
const _hoisted_112 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_113 = { class: "info-item mb-4" }
const _hoisted_114 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_115 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_116 = { class: "info-item mb-4" }
const _hoisted_117 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_118 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_119 = { class: "info-item" }
const _hoisted_120 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_121 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_122 = { class: "fw-bold text-gray-800" }
const _hoisted_123 = { class: "mb-0" }
const _hoisted_124 = { class: "section-header mb-6" }
const _hoisted_125 = { class: "fw-bold text-dark mb-1" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_127 = { class: "row g-6" }
const _hoisted_128 = { class: "col-12" }
const _hoisted_129 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_130 = { class: "info-item mb-4" }
const _hoisted_131 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_132 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_133 = { class: "text-gray-800" }
const _hoisted_134 = { class: "info-item mb-4" }
const _hoisted_135 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_136 = {
  class: "info-value p-3 bg-white rounded border border-gray-200",
  dir: "rtl"
}
const _hoisted_137 = { class: "text-gray-800" }
const _hoisted_138 = { class: "info-item mb-4" }
const _hoisted_139 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_140 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_141 = { class: "text-gray-800" }
const _hoisted_142 = { class: "row g-4" }
const _hoisted_143 = { class: "col-md-6" }
const _hoisted_144 = { class: "info-item" }
const _hoisted_145 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_146 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_147 = { class: "text-gray-800" }
const _hoisted_148 = { class: "col-md-6" }
const _hoisted_149 = { class: "info-item" }
const _hoisted_150 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_151 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_152 = { class: "text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_ctx.can('read', 'auctions') && _ctx.property)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.can('update', 'auctions'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary me-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('auctions-properties-editing')))
                    }, [
                      _createElementVNode("span", _hoisted_6, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('updateProperty')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-light",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('backToList')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.translate('basicInfo')), 1),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('propertyId')) + ":", 1),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.property.propertyId), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate('uniqueIdentifier')) + ":", 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.property.uniqueIdentifier), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.translate('block')) + ":", 1),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.property.block), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('plot')) + ":", 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.property.plot), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('paciNo')) + ":", 1),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.property.paciNo || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.translate('size')) + ":", 1),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.property.size) + " m²", 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate('area')) + ":", 1),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.property.areas?.titleEn || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('propertyType')) + ":", 1),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.property.auctions_property_types?.titleEn || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.translate('propertyDescription')) + ":", 1),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.property.auctions_property_descriptions?.titleEn || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('location')) + ":", 1),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.property.auctions_locations || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('createdAt')) + ":", 1),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.formatDate(_ctx.property.createdAt)), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("h3", _hoisted_63, _toDisplayString(_ctx.translate('pricingInfo')), 1),
                _hoisted_64
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.translate('startingPrice')) + ":", 1),
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.formatCurrency(_ctx.property.startingPrice)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.translate('startingPricePerSqrM')) + ":", 1),
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.formatCurrency(_ctx.property.startingPricePerSqrM)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.translate('salePrice')) + ":", 1),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.formatCurrency(_ctx.property.salePrice)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.translate('salePricePerSqrM')) + ":", 1),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.formatCurrency(_ctx.property.salePricePerSqrM)), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("h3", _hoisted_91, _toDisplayString(_ctx.translate('statusInfo')), 1),
                _hoisted_92
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.translate('auctionStatus')) + ":", 1),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.property.auctions_status?.titleEn || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.translate('accountStatus')) + ":", 1),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge ${
                        _ctx.property.isActive ? 'badge-success' : 'badge-secondary'
                      } fw-bold`)
                        }, _toDisplayString(_ctx.property.isActive
                          ? _ctx.translate('active')
                          : _ctx.translate('inactive')), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.translate('paidPercentage')) + ":", 1),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.property.paidPercentage || 'N/A') + "%", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.translate('premiumPaid')) + ":", 1),
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.property.percentagePremiumPaid || 'N/A') + "%", 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.translate('loanRequest')) + ":", 1),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge ${
                        _ctx.property.loan_request
                          ? 'badge-success'
                          : 'badge-secondary'
                      } fw-bold`)
                        }, _toDisplayString(_ctx.property.loan_request
                          ? _ctx.translate('available')
                          : _ctx.translate('notAvailable')), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.translate('certifiedCheckRequest')) + ":", 1),
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge ${
                        _ctx.property.certified_check_request
                          ? 'badge-success'
                          : 'badge-secondary'
                      } fw-bold`)
                        }, _toDisplayString(_ctx.property.certified_check_request
                          ? _ctx.translate('required')
                          : _ctx.translate('notRequired')), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.translate('supplyPercentage')) + ":", 1),
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.property.supplyPercentage || 'N/A') + "%", 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("h3", _hoisted_125, _toDisplayString(_ctx.translate('additionalDetails')), 1),
                _hoisted_126
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("label", _hoisted_131, _toDisplayString(_ctx.translate('additionalInfoEn')) + ":", 1),
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.property.additionalInfoEn || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.translate('additionalInfoAr')) + ":", 1),
                      _createElementVNode("div", _hoisted_136, [
                        _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.property.additionalInfoAr || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.translate('address')) + ":", 1),
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.property.address || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("div", _hoisted_144, [
                          _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.translate('longitude')) + ":", 1),
                          _createElementVNode("div", _hoisted_146, [
                            _createElementVNode("span", _hoisted_147, _toDisplayString(_ctx.property.longitude || 'N/A'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("div", _hoisted_149, [
                          _createElementVNode("label", _hoisted_150, _toDisplayString(_ctx.translate('latitude')) + ":", 1),
                          _createElementVNode("div", _hoisted_151, [
                            _createElementVNode("span", _hoisted_152, _toDisplayString(_ctx.property.latitude || 'N/A'), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}